import React from 'react';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import FreeTierManagementTab from '../components/admin/FreeTierManagementTab';
import { useSafeMode } from '../contexts/SafeModeContext';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { cn } from '../lib/utils';
import { useEffect } from 'react';
import { toast } from 'sonner';

const AdminFreeTierPage = () => {
  const { getThemeColors } = useSafeMode();
  const { user } = useAuth();
  const navigate = useNavigate();
  const colors = getThemeColors();

  useEffect(() => {
    if (user && user.role !== 'admin') {
      toast.error('Admin access required');
      navigate('/dashboard');
    }
  }, [user, navigate]);

  if (!user || user.role !== 'admin') {
    return (
      <div className={cn("flex h-screen", colors.bgPrimary)}>
        <Sidebar />
        <div className="flex-1 flex items-center justify-center">
          <Loader2 className={cn("w-8 h-8 animate-spin", colors.textMuted)} />
        </div>
      </div>
    );
  }

  return (
    <div className={cn("flex h-screen", colors.bgPrimary)}>
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          <div className="mb-6">
            <h1 className={cn("text-2xl font-bold", colors.textPrimary)}>Free Tier Management</h1>
            <p className={cn("text-sm", colors.textMuted)}>Configure the Product Explorer free tier experience</p>
          </div>
          <FreeTierManagementTab colors={colors} />
        </main>
      </div>
    </div>
  );
};

export default AdminFreeTierPage;
